import { useParams } from "react-router-dom";

// React Bootstrap components
import { Card } from "react-bootstrap";

// Components
import TabCardHeader from "../../../ui/TabCardHeader";
import StroskovnaMestaClanicCardItem from "./StroskovnaMestaClanicCardItem";
import AccessDenied from "../../../ui/AccessDenied";

//api calls
import { useGetStroskovnaMestaClanice } from "../../../../services/ProjectDetails/financeAPI";

// Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";
import useRoleCheck from "../../../../auth/useRoleCheck";
import useClanicaCheck from "../../../../auth/useClanicaCheck";

// Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const StroskovnaMesta = () => {
  const { id } = useParams();
  const { project } = useProjectDetailsContext();
  const { isEditor, isFakultetniSkrbnik } = useRoleCheck(MODULES.PROJEKTI);

  const { isUserClanicaInList } = useClanicaCheck(null, project?.clanice ?? []);

  // Editor always sees stroškovna mesta; fakultetni skrbnik only if their clanica is on this project
  const canViewStroskovnaMesta =
    isEditor || (isFakultetniSkrbnik && isUserClanicaInList);

  const { data: stroskovnaMestaClanic = [], isLoading } =
    useGetStroskovnaMestaClanice(id);

  if (isLoading) {
    return (
      <Card className="mb-4">
        <TabCardHeader title="Stroškovna mesta" showEditButton={false} />
        <div className="px-4 pt-4 pb-2">
          <p>Nalaganje stroškovnih mest...</p>
        </div>
      </Card>
    );
  }

  return (
    <RoleGuard
      moduleKey={MODULES.PROJEKTI}
      roles={ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI}
      fallback={<AccessDenied />}
    >
      {canViewStroskovnaMesta && (
        <Card className="mb-4">
          <TabCardHeader title="Stroškovna mesta" showEditButton={false} />
          <div className="px-4 pt-4 pb-2">
            <h6 className="form-section-heading">
              Stroškovna mesta in stroškovni nosilci po članicah
            </h6>
            {stroskovnaMestaClanic.map((stroskovnoMesto) => (
              <StroskovnaMestaClanicCardItem
                key={stroskovnoMesto.clanicaID}
                stroskovnoMestoClanice={stroskovnoMesto}
              />
            ))}
          </div>
        </Card>
      )}
    </RoleGuard>
  );
};

export default StroskovnaMesta;
